import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Data } from '@angular/router';
import { CrudService } from '../services/crud.service';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CountdownComponent } from 'ngx-countdown';
import * as moment from 'moment';

@Component({
    selector: 'app-event',
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.scss'],
})
export class EventComponent implements OnInit {
    displayURL;
    carousels = [];
    BestFly: any;
    Date = '';
    countdownDays = 0;
    DifferenceInTime = 0;
    wether = {
        temp_max: 0,
        temp_min: 0,
    };

    ads_images: any = {};

    selectedEvent = JSON.parse(localStorage.getItem('dataSource'));
    constructor(
        private sanitizer: DomSanitizer,
        private Router: ActivatedRoute,
        private http: HttpClient,
        private CrudService: CrudService,
    ) {
        let strvideo = this.selectedEvent.linkvideo;
        let key = strvideo.split('/')[3];
        this.displayURL = sanitizer.bypassSecurityTrustResourceUrl(
            'https://www.youtube.com/embed/' + key + '?autoplay=1&mute=1',
        );

        this.ads_images = {
            Home1: {
              img: '',
              link: ''
            },
            Home3: {
              img: '',
              link: ''
            }
          };

        this.loadData();
    }

    loadData(): void {
        this.CrudService.getProducts().subscribe(res => {
            this.ads_images = res[3];
            console.log(res);
        });
    }

    ngOnInit() {
        const self = this;
        var imgs = new Object();
        imgs = this.selectedEvent.imgs;
        var flys = new Object();
        flys = this.selectedEvent.Vuelos;
        this.getBestFly(flys);
        this.Date = this.formateDate(this.selectedEvent.fecha);
        this.selectedEvent.Hotel.precio = this.selectedEvent.Hotel.precio.split('-')[0];
        let i= 0;
        Object.keys(imgs).forEach(function (rkey, row) {
            if (imgs[rkey].img) self.carousels.push(imgs[rkey].img);
        });

        
        this.getCountdown(this.selectedEvent.fecha);
        this.getWether(this.selectedEvent.a_lat, this.selectedEvent.a_long);
        // console.log(this.countdown.begin());
    }
    formateDate(date) {
        let dateArry = {
            '01': 'JAN',
            '02': 'FEB',
            '03': 'MAR',
            '04': 'APR',
            '05': 'MAR',
            '06': 'JUN',
            '07': 'JUL',
            '08': 'AUG',
            '09': 'SEP',
            '10': 'OCT',
            '11': 'NOV',
            '12': 'DEC',
        };
        let str = date.split('/');

        return dateArry[str[1]] + '-' + str[0];
    }
    getBestFly(flys) {
        let max_price = 0;
        let betFly;
        Object.keys(flys).forEach(function (rkey, row) {
            var price = Number(flys[rkey].precio.replace(/[^0-9.-]+/g, ''));
            if (max_price < price) {
                max_price = price;
                betFly = flys[rkey];
            }
        });
        this.BestFly = betFly;
        console.log(max_price, this.BestFly);
    }

    getCountdown(targetDate) {
        // targetDate = targetDate.split('/')[2] + '/' + targetDate.split('/')[1] + '/' + targetDate.split('/')[0];
        console.log('target', targetDate);

        let date1 = moment();
        let date2 = moment(targetDate+' 7:00:00', 'DD/MM/YYYY h:mm:ss');

        // Difference in time (Expressed in seconds)
        this.DifferenceInTime = date2.diff(date1, 'seconds');

        // Difference in days
        this.countdownDays = date2.diff(date1, 'days');
    }

    getWether(lat, lon) {
        this.CrudService.getWether(lat, lon).subscribe((res) => {
            // console.log('clima: ', res);
            this.wether = res;
            this.wether.temp_min = Math.floor(res.main.temp_min);
            this.wether.temp_max = Math.floor(res.main.temp_max);
        });
    }
}
